import { isIpad } from './is-ipad';
import { isMac } from './is-mac';
export var getOsName = function () {
    if (/Win/.test(navigator.appVersion) && !/Mac/.test(navigator.appVersion)) {
        return 'windows';
    }
    if (/Android/.test(navigator.appVersion)) {
        return 'android';
    }
    // iOS和Mac的顺不能变，经测试发现Mac的浏览器里会有iOS的字样
    if (/iPhone/.test(navigator.appVersion)) {
        return 'ios';
    }
    if (isIpad()) {
        return 'ios';
    }
    if (isMac()) {
        return 'mac';
    }
    if (navigator.userAgent.includes('Linux')) {
        return 'linux';
    }
    return 'unknown';
};
